/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.videos = {}
  Shopify.theme.jsVideo = {
    init: function ($section) {
      const id = this.id
      if (!id)
        return
      Shopify.theme.videos[id] = {
        $video: $section.find('[data-video-element]'),
        $playIcon: $section.find('.plyr--paused.plyr--video .plyr__control--overlaid'),
        $button: $section.find('[data-play-button]'),
        $text: $section.find('[data-video-text-container]'),
        $image: $section.find('[data-image-element]'),
        $overlayBtn: $section.find('[data-overlay-trigger]'),
        $overlayWrapper: $section.find('[data-overlay]'),
        $overlayCloseBtn:$section.find('[data-overlay-close-trigger]'),
      }
      // Add settings from schema to current object
      Shopify.theme.jsVideo = $.extend(this, Shopify.theme.getSectionData($section));
      Shopify.theme.videos[id] = $.extend(Shopify.theme.videos[id], Shopify.theme.getSectionData($section));
      // Load video if the media has been added
      if (this.iframe_video || this.html5_video) {
        this.loadVideo(id);
      } else {
        Shopify.theme.videos[id].$image.show();
      }

      if (this.is_overlaid_video) {
        this.handleOverlay(id)
      }

    },
    handleOverlay: function (id) {
      const { $overlayWrapper, $overlayBtn, $overlayCloseBtn, player } = Shopify.theme.videos[id]
      $overlayBtn.on('click', () => {
        console.log('click')
        $overlayWrapper.addClass('is-active')
        setTimeout(function () {
          player.play()
        }, 500)
      })
      $overlayCloseBtn.on('click', () => {
        player.pause()
        $overlayWrapper.removeClass('is-active')
      })

    },
    loadVideo: function (id) {
      const { autoloop, $video, $playIcon, $button, $text, $image, mute, aspect_ratio, autoplay } = Shopify.theme.videos[id]
      const player = new Plyr(`.video-${id.replace('shopify-section-','')}`, {
        controls: videoControls,
        loop: {
          active: autoloop
        },
        fullscreen: {
          enabled: true,
          fallback: true,
          iosNative: true
        },
        storage: {
          enabled: false
        }
      });

      player.muted = mute;
      player.ratio = aspect_ratio;
      console.log($video)

      // If autoplay enabled, hide image and text
      if (autoplay) {
        player.autoplay = true;
        $image && $image.hide();
        $text && $text.hide();
        $video.show();
      } else {
        // If autoplay disabled, check if poster image added
        if (this.poster) {
          $video.hide();
          $image && $image.show();
          $text && $text.show();
        } else {
          // If autoplay disabled and no poster image
          $image && $image.hide();
          $video.show();
          $text && $text.show();
        }
      }

      // If button exists, clicking button will play video
      if ($button) {
        $button.on('click', () => {
          player.play();
        })
      }

      // Clicking anywhere on video should play the video
      if (!$button) {
        $text.on('click', () => {
          player.play();
        })
      }

      // If on mobile and text is below image, clicking the image wrapper should play the video
      if (!isScreenSizeLarge() && $video.parents('.mobile-text--below-media')) {
        $image.on('click', () => {
          player.play();
        })
      }

      // On player ready, hide play icon if play button visible
      player.on('ready', function (index, player) {
        if ($button && !isScreenSizeLarge() && $video.parents('.mobile-text--below-media')) {
          $playIcon.show();
        } else if ($button) {
          $playIcon.hide();
        } else {
          $playIcon.show();
        }
      })

      // On play, hide image/text and show video element
      player.on('play', function (index, player) {
        $video.show();
        $image && $image.hide();
        $text && $text.hide();
      })

      // On player pause, show play icon if play button hidden
      player.on('pause', function (index, player) {
        if (!$button) {
          $playIcon.show();
        }
      })
      Shopify.theme.videos[id].player = player
    },
    unload: function ($section) {
      const $button = $section.find('[data-play-button]');
      const $text = $section.find('[data-video-text-container]');

      $button.off();
      $text.off();
    }
  }

  /******/
})()
  ;